import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\MarketStatsController::__invoke
* @see app/Http/Controllers/Api/Internal/MarketStatsController.php:35
* @route '/internal-api/market-stats'
*/
export const show = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/internal-api/market-stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Internal\MarketStatsController::__invoke
* @see app/Http/Controllers/Api/Internal/MarketStatsController.php:35
* @route '/internal-api/market-stats'
*/
show.url = (options?: RouteQueryOptions) => {
    return show.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\MarketStatsController::__invoke
* @see app/Http/Controllers/Api/Internal/MarketStatsController.php:35
* @route '/internal-api/market-stats'
*/
show.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Internal\MarketStatsController::__invoke
* @see app/Http/Controllers/Api/Internal/MarketStatsController.php:35
* @route '/internal-api/market-stats'
*/
show.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(options),
    method: 'head',
})

const marketStats = {
    show: Object.assign(show, show),
}

export default marketStats